import React from 'react';

import RecommendedArticles from '@components/SideFeedItems/RecommendedArticles';

import OrgChartBoardOfDirectors from './BoardOfDirectors';
import OrgChartCompanyQuickFacts from './CompanyQuickFacts';
import { OrgChartCompanyRightRailProps } from './interfaces';

const OrgChartCompanyRightRail = (props: OrgChartCompanyRightRailProps) => {
  return (
    <div
      className="mt-64 flex-1 border-b-0 border-l-0 border-r-0 border-t border-solid border-grayscale-gray pt-12 md:mt-0 md:border-l md:border-t-0 md:pl-28 md:pt-0 lg:pl-56"
      data-testid="side-feed"
    >
      {props.recommendedArticles?.length > 0 && (
        <RecommendedArticles recommendedArticles={props.recommendedArticles} />
      )}
      {props.quickFacts?.length > 0 && <OrgChartCompanyQuickFacts quickFacts={props.quickFacts} />}

      {props.directors?.length > 0 && <OrgChartBoardOfDirectors directors={props.directors} />}
    </div>
  );
};

export default OrgChartCompanyRightRail;
